import { CartShippingHeader } from './CartShippingHeader';

export type { TypeCartShippingHeaderProps } from './types';
export default CartShippingHeader;
